module.exports = __webpack_public_path__ + "static/img/banner_8.f8cf614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_8.jpg
// module id = wJFZ
// module chunks = 0